import React from 'react';
import imgProfile from '../../../resources/img/user-icon-big.png';
import Parser from 'html-react-parser';
import { API_URL } from "../../../../SHARED/config/apiEndpoints";

const NewsAuthoBiography = ({image, name, biography}) => {
        return (
            <div className="news-details-biography">
                <div className="news-details-auhor clearfix">
                    <div className="lefty">
                        <img alt={'Autor'} className="rounded-circle" src={image !== '' ? API_URL + image : imgProfile} width="100" height="100"/>
                    </div>
                    <div className="news-details-righty float-left"> 
                        <div className="news-details-auhor-name">
                            <span className="comment-name">{name !== undefined ? Parser(name) : ""}</span>
                        </div>
                            <div className="news-details-auhor-biography">
                                <span className="comment-name">{biography !== undefined ? Parser(biography) : ""}</span>
                            </div>
                        </div>
                    </div>
            </div>
        );
    }

export default NewsAuthoBiography;


// WEBPACK FOOTER //
// ./src/FO/components/newsdetails/containers/newsauthorbiography.component.js